import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { forwardRef } from 'react';
import { c as classNames } from '../../../shared/bind-a2a3a613.js';
import { s as styles } from '../../../shared/Input-18ed845e.js';
import { getTestId } from '../../../utils/testId.js';
import { deprecationWarning } from '../../../utils/warning.js';
import { idFromName, computeId } from '../../../utils/html.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var INPUT_TEXT_STYLING_VALUES = ['tight', 'narrow', 'wide'];
var INPUT_TEXT_THEME_VALUES = ['primary'];
var INPUT_TEXT_TYPE_VALUES = ['text', 'password', 'number', 'email', 'date', 'datetime-local'];
var INPUT_TEXT_INPUT_MODE_VALUES = ['none', 'decimal', 'numeric', 'tel', 'search', 'email', 'url'];
/* ---------- Back-compat shim (deprecated) ---------- */
var INPUT_TEXT_STYLING = {
  Tight: 'tight',
  Narrow: 'narrow',
  Wide: 'wide'
};
var INPUT_TEXT_THEME = {
  Primary: 'primary'
};
var INPUT_TEXT_TYPE = {
  Text: 'text',
  Password: 'password',
  Number: 'number',
  Email: 'email',
  Date: 'date',
  DateTimeLocal: 'datetime-local'
};
var INPUT_TEXT_INPUT_MODE = {
  None: 'none',
  Decimal: 'decimal',
  Numeric: 'numeric',
  Telephone: 'tel',
  Search: 'search',
  Email: 'email',
  Url: 'url'
};

/* ---------- Type definitions ---------- */

var cssClasses = classNames.bind(styles);
var InputTextBase = function InputTextBase(_ref) {
  var name = _ref.name,
    idProp = _ref.id,
    validation = _ref.validation,
    title = _ref.title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    required = _ref.required,
    disabled = _ref.disabled,
    min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    maxLength = _ref.maxLength,
    defaultValue = _ref.defaultValue,
    suffix = _ref.suffix,
    placeholder = _ref.placeholder,
    autoComplete = _ref.autoComplete,
    readOnly = _ref.readOnly,
    styling = _ref.styling,
    theme = _ref.theme,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onKeyDown = _ref.onKeyDown,
    onCopy = _ref.onCopy,
    onChange = _ref.onChange,
    forwardedRef = _ref.forwardedRef,
    value = _ref.value,
    testId = _ref.testId,
    inputMode = _ref.inputMode,
    aria = _ref.aria;
  var inputClass = cssClasses(styles.input, styling, theme);
  var inputValueClass = cssClasses(styles.value, _defineProperty({}, styles['with-suffix'], !!suffix));
  var AccessibleWrapper = title ? 'label' : 'div';
  var baseId = idFromName(name);
  var computedId = computeId(idProp, baseId);
  return /*#__PURE__*/jsxs(AccessibleWrapper, {
    htmlFor: computedId,
    className: inputClass,
    "data-testid": testId,
    children: [title ? /*#__PURE__*/jsx("div", {
      className: styles.title,
      "data-testid": getTestId(testId, 'title'),
      children: title
    }) : null, /*#__PURE__*/jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/jsx("input", _objectSpread({
        className: inputValueClass,
        type: type,
        name: name,
        id: computedId,
        value: value === null ? undefined : value,
        required: required,
        disabled: disabled,
        min: min,
        max: max,
        step: step,
        maxLength: maxLength,
        defaultValue: defaultValue,
        placeholder: placeholder,
        autoComplete: autoComplete,
        readOnly: readOnly,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onCopy: onCopy,
        onKeyDown: onKeyDown,
        ref: forwardedRef,
        inputMode: inputMode,
        "data-testid": getTestId(testId, 'input')
      }, aria)), suffix ? /*#__PURE__*/jsx("div", {
        className: styles.suffix,
        children: suffix
      }) : null]
    }), validation ? /*#__PURE__*/jsx("div", {
      className: styles.note,
      children: validation
    }) : null]
  });
};

/** The public component type: a React component value that also has deprecated statics */

// BUG: default exports do not auto-generate storybook ArgsTable
// https://github.com/storybookjs/storybook/issues/9511
// remove export when resolved
var InputTextWithForwardedRefBase = /*#__PURE__*/forwardRef(function (props, ref) {
  var forwardedProps = _objectSpread({}, props);
  if (forwardedProps.deprecatedIcon) {
    forwardedProps.suffix = forwardedProps.suffix || forwardedProps.deprecatedIcon;
    deprecationWarning('Property icon on InputText component has been deprecated. Use property suffix instead');
  }
  return /*#__PURE__*/jsx(InputTextBase, _objectSpread({
    forwardedRef: ref
  }, forwardedProps));
});
InputTextWithForwardedRefBase.displayName = InputTextBase.name;

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var InputTextWithForwardedRef = _Object$assign(InputTextWithForwardedRefBase, {
  /** @deprecated Use string unions, e.g. styling="tight" */
  Styling: INPUT_TEXT_STYLING,
  /** @deprecated Use string unions, e.g. theme="primary" */
  Theme: INPUT_TEXT_THEME,
  /** @deprecated Use string unions, e.g. type="email" */
  Type: INPUT_TEXT_TYPE,
  /** @deprecated Use string unions, e.g. inputMode="numeric" */
  InputMode: INPUT_TEXT_INPUT_MODE
});

export { INPUT_TEXT_INPUT_MODE, INPUT_TEXT_INPUT_MODE_VALUES, INPUT_TEXT_STYLING, INPUT_TEXT_STYLING_VALUES, INPUT_TEXT_THEME, INPUT_TEXT_THEME_VALUES, INPUT_TEXT_TYPE, INPUT_TEXT_TYPE_VALUES, InputTextWithForwardedRef, InputTextWithForwardedRef as default };
//# sourceMappingURL=InputText.js.map
